(() => {
  if (window.__hbDropdownInit) return;
  window.__hbDropdownInit = true;

  function initDropdown(root) {
    const toggle = root.querySelector(".js-db-toggle");
    const menu = root.querySelector(".db-menu");
    if (!toggle || !menu) return;

    // avoid double-binding if Shopify re-renders sections
    if (root.__hbDropdownBound) return;
    root.__hbDropdownBound = true;

    const label = root.querySelector(".js-db-label");

    function open() {
      toggle.setAttribute("aria-expanded", "true");
      menu.hidden = false;
      menu.focus?.();
    }

    function close() {
      toggle.setAttribute("aria-expanded", "false");
      menu.hidden = true;
    }

    toggle.addEventListener("click", (e) => {
      e.preventDefault();
      const isOpen = toggle.getAttribute("aria-expanded") === "true";
      isOpen ? close() : open();
    });

    menu.addEventListener("click", (e) => {
      const opt = e.target.closest(".db-option");
      if (!opt) return;
      const url = opt.dataset.url;
      if (!url) return;

      if (label) label.textContent = opt.textContent.trim();
      close();
       window.open(url, "_blank", "noopener,noreferrer");
    });

    // close on outside click
    document.addEventListener("click", (e) => {
      if (!root.contains(e.target)) close();
    });

    // close on escape
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-hb-dropdown="true"]').forEach(initDropdown);
  }

  // initial
  document.addEventListener("DOMContentLoaded", () => initAll());

  // Shopify section reload support
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));

  // expose for manual use if needed
  window.hbInitDropdowns = initAll;
})();
